import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DashboardUsagePage } from '@apps/web/features/dashboard_usage/dashboard_usage_page';

export const Route = createFileRoute('/_app/admin/dashboard-usage')({
    component: DashboardUsageRoute,
    validateSearch: z.object({
        source: z
            .enum(['all', 'phoebe', 'datadog', 'posthog', 'hex', 'sentry'])
            .catch('all'),
        days: z.union([z.literal(7), z.literal(14), z.literal(30)]).catch(30),
        measurement: z
            .enum(['page_loads', 'dashboard_opens'])
            .catch('page_loads'),
    }),
    head: () => ({ meta: [{ title: 'Dashboard registry | Phoebe Admin' }] }),
});

function DashboardUsageRoute() {
    const filters = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
        <DashboardUsagePage
            {...filters}
            onFilterChange={(next) => {
                void navigate({
                    search: { ...filters, ...next },
                    replace: true,
                });
            }}
        />
    );
}
